import { render, staticRenderFns } from "./Avance.vue?vue&type=template&id=6fa5ba09&"
import script from "./Avance.vue?vue&type=script&lang=js&"
export * from "./Avance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports